"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PhaseLabel = function PhaseLabel(_ref) {
  var status = _ref.status,
      text = _ref.text,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["status", "text", "children"]);

  var red = ['REJECTED', 'REJECTED_RSR', 'REJECTED_NS', 'CANCELLED', 'REFUSED', 'SUSPENDED', 'TERMINATED', 'error', 'red'];
  var blue = ['PENDING', 'offer-send', 'blue'];
  var orange = ['warning', 'orange'];
  var yellow = ['SEND', 'contract-send', 'IN_PROGRESS', 'yellow'];
  var green = ['ACCEPTED', 'SIGNED', 'ACCEPTED', 'success', 'green'];
  var statusClassName = 'default';
  if (red.includes(status)) statusClassName = 'red';
  if (blue.includes(status)) statusClassName = 'blue';
  if (yellow.includes(status)) statusClassName = 'yellow';
  if (green.includes(status)) statusClassName = 'green';
  if (orange.includes(status)) statusClassName = 'orange';
  return /*#__PURE__*/_react.default.createElement(PhaseLabelWrapper, otherProps, /*#__PURE__*/_react.default.createElement(PhaseLabelIndicator, {
    className: statusClassName
  }), !children && text ? /*#__PURE__*/_react.default.createElement(PhaseLabelText, null, text) : '', children && !text ? children : '');
};

var PhaseLabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "PhaseLabelWrapper"
})(["display:flex;align-items:center;"]);

var PhaseLabelIndicator = _styledComponents.default.div.withConfig({
  displayName: "PhaseLabelIndicator"
})(["width:1.1rem;height:1.1rem;min-width:1.1rem;min-height:1.1rem;border-radius:50%;margin-right:0.8rem;border:0;display:inline-block;&.default{background-color:", ";}&.green{background-color:", ";}&.orange{background-color:", ";}&.blue{background-color:", ";}&.yellow{background-color:", ";}&.red{background-color:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.ui.outline;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.status.succes;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.status.warning;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.status.blue;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.status.yellow;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.status.error;
});

var PhaseLabelText = _styledComponents.default.div.withConfig({
  displayName: "PhaseLabelText"
})(["font-family:", ";font-size:1.2rem;line-height:120%;color:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.font;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.typo.title;
});

PhaseLabel.defaultProps = {
  status: 'default',
  otherProps: {}
};
PhaseLabel.propTypes = {
  /** The type of the indicator */
  status: _propTypes.string,

  /** The text to be displayed */
  text: _propTypes.string,
  children: _propTypes.node,
  otherProps: _propTypes.object
};
var _default = PhaseLabel;
exports.default = _default;